/* eslint-disable */
import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  HStack,
  Text,
  useColorModeValue,
  VStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Portal,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import authService from 'services/authService';
import {
  CollapsedSidebarItem,
  CollapsedIconButton,
  collapsedIconInnerSx,
  SIDEBAR_COLLAPSED_WIDTH,
} from './CollapsedSidebarItem';

export function SidebarLinks(props) {
  let location = useLocation();
  let activeColor = useColorModeValue('gray.700', 'white');
  let inactiveColor = useColorModeValue(
    'secondaryGray.600',
    'secondaryGray.600',
  );
  let activeIcon = useColorModeValue('gray.800', 'gray.300');
  let textColor = useColorModeValue('#003064', 'white');
  let brandColor = useColorModeValue('gray.800', 'gray.300');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const activeBg = useColorModeValue('gray.100', 'whiteAlpha.200');
  const menuListBg = useColorModeValue('white', 'navy.800');
  const menuBorderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const menuHeaderColor = useColorModeValue('gray.600', 'gray.300');
  const menuItemHoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');

  const { routes, collapsed } = props;

  const iconWrapSx = collapsedIconInnerSx;
  const menuItemTextColor = useColorModeValue('gray.700', 'white');

  const CollapsedCategoryPopover = ({
    route,
    accessibleItems,
    routeKey,
  }) => {
    return (
      <CollapsedSidebarItem key={routeKey}>
        <Box display="inline-flex" lineHeight={0}>
        <Popover
          placement="right"
          gutter={12}
          isLazy
          lazyBehavior="keepMounted"
          strategy="fixed"
        >
          <PopoverTrigger>
            <CollapsedIconButton
              bg="transparent"
              color={textColor}
              title={route.name}
              aria-label={route.name}
              _hover={{ bg: hoverBg }}
            >
              <Box as="span" sx={iconWrapSx} color="inherit">
                {route.icon}
              </Box>
            </CollapsedIconButton>
          </PopoverTrigger>
          <Portal>
            <PopoverContent
              w="220px"
              bg={menuListBg}
              borderColor={menuBorderColor}
              boxShadow="lg"
              zIndex={1500}
            >
              <PopoverBody p={2}>
                <Text
                  fontSize="sm"
                  fontWeight="bold"
                  color={menuHeaderColor}
                  mb={2}
                  px={1}
                >
                  {route.name}
                </Text>
                <VStack align="stretch" spacing={0}>
                  {accessibleItems.map((subRoute, subIndex) => (
                    <Box
                      key={subIndex}
                      as={NavLink}
                      to={subRoute.layout + subRoute.path}
                      display="flex"
                      alignItems="center"
                      px={3}
                      py={2}
                      borderRadius="md"
                      color={menuItemTextColor}
                      fontSize="sm"
                      _hover={{ bg: menuItemHoverBg }}
                      bg={
                        activeRoute(subRoute.path, subRoute.layout)
                          ? activeBg
                          : 'transparent'
                      }
                    >
                      {subRoute.icon && (
                        <Box
                          me={2}
                          sx={iconWrapSx}
                          color={
                            activeRoute(subRoute.path, subRoute.layout)
                              ? activeIcon
                              : textColor
                          }
                        >
                          {subRoute.icon}
                        </Box>
                      )}
                      <Text>{subRoute.name}</Text>
                    </Box>
                  ))}
                </VStack>
              </PopoverBody>
            </PopoverContent>
          </Portal>
        </Popover>
        </Box>
      </CollapsedSidebarItem>
    );
  };

  const CollapsedNavLink = ({ route, routeKey }) => {
    const isActive = activeRoute(route.path, route.layout);
    return (
      <CollapsedSidebarItem key={routeKey}>
        <CollapsedIconButton
          as={NavLink}
          to={route.layout + route.path}
          title={route.name}
          aria-label={route.name}
          bg={isActive ? activeBg : 'transparent'}
          color={isActive ? activeIcon : textColor}
          textDecoration="none"
          cursor="pointer"
          _hover={{ bg: hoverBg }}
          _focusVisible={{ boxShadow: '0 0 0 2px var(--chakra-colors-blue-400)' }}
        >
          <Box as="span" sx={iconWrapSx} color="inherit">
            {route.icon}
          </Box>
        </CollapsedIconButton>
      </CollapsedSidebarItem>
    );
  };

  // Estado para controlar qué acordeón está abierto
  const [openAccordion, setOpenAccordion] = useState(-1);

  const normalizePath = (path) => {
    const value = String(path || '').toLowerCase();
    if (!value || value === '/') return '/';
    return value.endsWith('/') ? value.slice(0, -1) : value;
  };

  /** Coincidencia exacta (evita marcar /purchase-invoices al estar en /purchase-invoices/new). */
  const activeRoute = (routePath, layout = '/admin') =>
    normalizePath(location.pathname) ===
    normalizePath(`${layout}${routePath}`);

  // Función para manejar el toggle de acordeones
  const handleAccordionToggle = (index) => {
    setOpenAccordion(openAccordion === index ? -1 : index);
  };

  // Función para verificar si el usuario puede ver una ruta
  const verifyPermissionFromStorage = (permission) => {
    return authService.constructor.checkPermissionFromStorage(permission);
  };

  const canAccessRoute = (route) => {
    console.log(`\n--- Verificando acceso a ruta: ${route.name} ---`);

    const isMechanicUser = authService.isMechanic();
    if (
      route.onlyRoles?.some((role) => role === 'Mecanico') &&
      !isMechanicUser
    ) {
      return false;
    }
    if (
      route.excludeRoles?.some(
        (role) => role === 'Mecanico' && isMechanicUser,
      )
    ) {
      return false;
    }
    
    // TEMPORAL: Usar función que lee directamente de localStorage
    // Verificar si hay permiso simple (compatibilidad hacia atrás)
    if (route.permission) {
      const hasAccess = verifyPermissionFromStorage(route.permission);
      console.log(`Resultado acceso para ${route.name} (permission):`, hasAccess);
      return hasAccess;
    }

    // Verificar rol específico si se requiere
    if (route.requiredRole) {
      try {
        const userData = localStorage.getItem('userData');
        if (userData) {
          const user = JSON.parse(userData);
          const hasRole = user.role === route.requiredRole || user.role === 'Admin';
          console.log(`Rol requerido: ${route.requiredRole}, Usuario: ${user.role}, Acceso:`, hasRole);
          if (!hasRole) {
            console.log('❌ Acceso denegado por rol:', route.name);
            return false;
          }
        }
      } catch (error) {
        console.error('Error verificando rol:', error);
        return false;
      }
    }

    // Verificar permisos específicos si se requieren
    if (route.requiredPermissions && route.requiredPermissions.length > 0) {
      let hasPermission = false;
      
      if (route.requireAny) {
        // Verificar si tiene al menos uno de los permisos
        hasPermission = route.requiredPermissions.some(permission => 
          verifyPermissionFromStorage(permission)
        );
      } else {
        // Verificar si tiene todos los permisos
        hasPermission = route.requiredPermissions.every(permission => 
          verifyPermissionFromStorage(permission)
        );
      }
      
      if (!hasPermission) {
        console.log('❌ Acceso denegado por permisos:', route.name);
        return false;
      }
    }

    console.log('✅ Acceso permitido:', route.name);
    return true;
  };

  // Función para verificar si se puede acceder a una categoría
  const canAccessCategory = (category) => {
    if (!category.items) return canAccessRoute(category);
    
    // Si al menos una ruta de la categoría es accesible, mostrar la categoría
    return category.items.some(item => canAccessRoute(item));
  };

  const createLinks = (routes) => {
    let accordionIndex = 0; // Contador para acordeones
    
    const links = routes.map((route, index) => {
      if (route.name === 'Sign In') return null;

      // Verificar acceso a la ruta/categoría
      if (!canAccessCategory(route)) {
        return null;
      }

      if (route.layout === '/admin' || route.layout === '/auth') {
        if (route.category && route.items?.length) {
          const currentAccordionIndex = accordionIndex;
          accordionIndex++; // Incrementar para el próximo acordeón
          
          // Filtrar items según permisos
          const accessibleItems = route.items.filter(item => 
            item.showInNavbar !== false && canAccessRoute(item)
          );

          // Si no hay items accesibles, no mostrar la categoría
          if (accessibleItems.length === 0) {
            return null;
          }
          
          if (collapsed) {
            return (
              <CollapsedCategoryPopover
                key={index}
                routeKey={index}
                route={route}
                accessibleItems={accessibleItems}
              />
            );
          }
          
          return (
            <Box key={index} border="none" mb="4px">
              <Box border="none" borderRadius="12px">
                <Box 
                  py="12px"
                  px="16px"
                  cursor="pointer"
                  onClick={() => handleAccordionToggle(currentAccordionIndex)}
                  borderRadius="12px"
                  transition="all 0.2s"
                  _hover={{ bg: useColorModeValue('gray.50', 'whiteAlpha.100') }}
                  minH="48px"
                >
                  <Flex w="100%" alignItems="center" justify="space-between" h="100%">
                    <Flex alignItems="center">
                      <Box color={textColor} me="18px" sx={iconWrapSx}>
                        {route.icon}
                      </Box>
                      <Text
                        fontSize="sm"
                        fontWeight="normal"
                        color={activeColor}
                      >
                        {route.name}
                      </Text>
                    </Flex>
                    <ChevronDownIcon 
                      transform={openAccordion === currentAccordionIndex ? 'rotate(180deg)' : 'rotate(0deg)'}
                      transition="transform 0.2s"
                      w={4}
                      h={4}
                      color={textColor}
                    />
                  </Flex>
                </Box>
                <Box 
                  overflow="hidden"
                  transition="all 0.3s ease-in-out"
                  maxH={openAccordion === currentAccordionIndex ? "1200px" : "0px"}
                  opacity={openAccordion === currentAccordionIndex ? 1 : 0}
                >
                  <Box pt="8px" pb="16px">
                    <VStack align="start" spacing={2} pl={4}>
                      {accessibleItems.map((subRoute, subIndex) => (
                        <NavLink
                          key={subIndex}
                          to={subRoute.layout + subRoute.path}
                          style={{ width: '100%' }}
                        >
                          <Box
                            py="8px"
                            px="12px"
                            borderRadius="8px"
                            transition="background 0.2s"
                            _hover={{ bg: useColorModeValue('gray.100', 'whiteAlpha.200') }}
                            bg={
                              activeRoute(subRoute.path, subRoute.layout)
                                ? useColorModeValue('gray.100', 'whiteAlpha.200')
                                : 'transparent'
                            }
                          >
                            <HStack spacing="12px">
                              <Flex w="100%" alignItems="center">
                                {subRoute.icon && (
                                  <Box
                                    color={
                                      activeRoute(subRoute.path, subRoute.layout)
                                        ? activeIcon
                                        : textColor
                                    }
                                    me="18px"
                                    sx={iconWrapSx}
                                  >
                                    {subRoute.icon}
                                  </Box>
                                )}
                                <Text
                                  me="auto"
                                  color={
                                    activeRoute(subRoute.path, subRoute.layout)
                                      ? activeColor
                                      : textColor
                                  }
                                  fontWeight={
                                    activeRoute(subRoute.path, subRoute.layout)
                                      ? 'bold'
                                      : 'normal'
                                  }
                                  fontSize="sm"
                                >
                                  {subRoute.name}
                                </Text>
                              </Flex>
                              <Box
                                h="36px"
                                w="4px"
                                bg={
                                  activeRoute(subRoute.path, subRoute.layout)
                                    ? brandColor
                                    : 'transparent'
                                }
                                borderRadius="5px"
                              />
                            </HStack>
                          </Box>
                        </NavLink>
                      ))}
                    </VStack>
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        } else {
          // Ruta individual
          if (route.showInNavbar === false) {
            return null;
          }

          if (collapsed) {
            return <CollapsedNavLink route={route} routeKey={index} />;
          }
          
          return (
            <NavLink key={index} to={route.layout + route.path}>
              <Box>
                <HStack
                  spacing={
                    activeRoute(route.path, route.layout) ? '22px' : '26px'
                  }
                  py="12px"
                  ps="16px"
                  minH="48px"
                  borderRadius="12px"
                  transition="all 0.2s"
                  _hover={{ bg: useColorModeValue('gray.50', 'whiteAlpha.100') }}
                  bg={
                    activeRoute(route.path, route.layout)
                      ? useColorModeValue('gray.100', 'whiteAlpha.200')
                      : 'transparent'
                  }
                >
                  <Flex w="100%" alignItems="center">
                    {route.icon && (
                      <Box
                        color={
                          activeRoute(route.path, route.layout)
                            ? activeIcon
                            : textColor
                        }
                        me="18px"
                        sx={iconWrapSx}
                      >
                        {route.icon}
                      </Box>
                    )}
                    <Text
                      me="auto"
                      color={
                        activeRoute(route.path, route.layout)
                          ? activeColor
                          : textColor
                      }
                      fontWeight={
                        activeRoute(route.path, route.layout)
                          ? 'bold'
                          : 'normal'
                      }
                      fontSize="sm"
                    >
                      {route.name}
                    </Text>
                  </Flex>
                  <Box
                    h="36px"
                    w="4px"
                    bg={
                      activeRoute(route.path, route.layout)
                        ? brandColor
                        : 'transparent'
                    }
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            </NavLink>
          );
        }
      }
    }).filter(Boolean); // Filtrar elementos null
    
    return links;
  };

  if (collapsed) {
    return (
      <Flex
        direction="column"
        align="center"
        w={`${SIDEBAR_COLLAPSED_WIDTH}px`}
        gap="2px"
      >
        {createLinks(routes)}
      </Flex>
    );
  }

  return (
    <Box w="100%">
      <VStack align="stretch" spacing={1} w="100%">
        {createLinks(routes)}
      </VStack>
    </Box>
  );
}

export default SidebarLinks;